import { a125, a128, a149, a159, a188, a716, a730, a733, a754, a755,  a758, j760, j761, j762 } from "Components/Api/RootApiPath";

export const fetchQuotationNumber = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(j762, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice number"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw new Error(`${"Failed to fetch invoice number, try again later"}`);
  }
};


export const fetchQuotationList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(j760, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};
export const fetchQuotation = async ({id, clientCode}) => {
  try {
    const data = await fetch(j761, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, clientCode }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    console.log(e)
    throw new Error(`${"Failed to fetch invoice, try again later"}`)
  }
};

export const fetchVendorsList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a149, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllRDPurchaseList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a159, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllCategoryList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllProductTypes = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchLotAuditReports = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a733, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const partyOutstandingReports = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a758, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch party outstanding"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchBranchList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a716, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};
